<!-- src/app/pages/cost-metrics/cost-saving/cost-savings.component.html -->
<div class="cost-savings-page p-4 space-y-6">
    <!-- Header/context -->
    <header class="flex items-center justify-between">
        <!-- <div class="text-sm text-gray-600">
    <span class="font-medium">Year:</span> {{ resolvedYearForHeader || '—' }}
    <span class="ml-3 font-medium">Range:</span> {{ range }}
  </div> -->
    </header>

    <div class="flex costSavingsBlk">
        <!-- Group 1: Diagnosed, Treated, Controlled + Primary care cost -->
        <section class="space-y-4 primaryCare">
            <!-- KPI cards: Diagnosed, Treated, Controlled -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                @for (k of kpiCards | slice: 0 : 3; track k) {
                    <div class="border rounded-lg p-4 bg-white shadow-sm">
                        <div class="flex items-center justify-between mb-2">
                            <div class="savLabel">{{ k.label }}</div>
                            <i [class]="k.icon + ' text-2xl text-gray-500'"></i>
                        </div>
                        <div class="flex items-center gap-3 mt-3">
                            <span class="savPercent">{{ k.percent }} %</span>
                            <div class="savValue">{{ k.count | number }}</div>
                        </div>
                    </div>
                }
            </div>

            <!-- Primary care cost summary -->
            <div class="border rounded-lg p-4 bg-white shadow-sm bottomBlk">
                <div class="bottomBlkHead">Primary care cost ($)</div>
                <div class="bottomBlkInner">
                    <div class="text-center">
                        <div class="bottomBlkSmall">Base</div>
                        <div class="bottomBlkValue">{{ formatCost(primaryCost.base) }}</div>
                    </div>
                    <div class="text-center">
                        <div class="bottomBlkSmall">Current</div>
                        <div class="bottomBlkValue">{{ formatCost(primaryCost.current) }}</div>
                    </div>
                    <div class="text-center">
                        <div class="bottomBlkSmall">Difference</div>
                        <div class="bottomBlkValue">
                            {{ formatCost(primaryCost.diff) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Group 2: CVD patients, CVD events + Secondary care cost -->
        <section class="space-y-4 secondaryCare">
            <!-- KPI cards: CVD patients, CVD events -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                @for (k of kpiCards | slice: 3 : 5; track k) {
                    <div class="border rounded-lg p-4 bg-white shadow-sm">
                        <div class="flex items-center justify-between mb-2">
                            <div class="savLabel">{{ k.label }}</div>
                            <i [class]="k.icon + ' text-2xl text-gray-500'"></i>
                        </div>
                        <div class="flex items-center gap-3 mt-3">
                            <span class="savPercent">{{ k.percent }} %</span>
                            <div class="savValue">{{ k.count | number }}</div>
                        </div>
                    </div>
                }
            </div>

            <!-- Secondary care cost summary -->
            <div class="border rounded-lg p-4 bg-white shadow-sm bottomBlk">
                <div class="bottomBlkHead">Secondary care cost ($)</div>
                <div class="bottomBlkInner gap-6">
                    <div class="text-center">
                        <div class="bottomBlkSmall">Base</div>
                        <div class="bottomBlkValue">{{ formatCost(secondaryCost.base) }}</div>
                    </div>
                    <div class="text-center">
                        <div class="bottomBlkSmall">Current</div>
                        <div class="bottomBlkValue">{{ formatCost(secondaryCost.current) }}</div>
                    </div>
                    <div class="text-center">
                        <div class="bottomBlkSmall">Difference</div>
                        <div class="bottomBlkValue">
                            {{ formatCost(secondaryCost.diff) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
